import {Button} from "@mui/material";
import * as React from "react";

/*
    Find vouchers
    @param {object} row
    @param {function} setCurrentRow
    @param {function} setShowModal
 */
export default function VouchersFindRedeemButton({row, setCurrentRow, setShowModal}){

    if(row.is_redeemed > 0) return (
        <Button variant="contained" sx={{background:'red', width:'100%'}}
                disabled={(row.campaign_available === 0)}
                onClick={()=>{
                    setCurrentRow(row);
                    setShowModal(true);
                }}>{ (row.campaign_available > 0) ? "Redeemed" : "No action available"}</Button>
    )

    return (
        <Button variant="contained" sx={{width:'100%'}}
                onClick={()=>{
                    setCurrentRow(row);
                    setShowModal(true);
                }}>Redeem</Button>
    )
}
